<template>
  <McButton
    variant="secondary"
    icon="icon-fill_share"
    :text="hideText ? '' : computedText"
    :disabled="shareTrackDisabled"
    :size="size"
    :displayTooltip="true"
    :tooltipText="tooltipText"
    @click="$emit('click', $event)"
  />
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    rawStatus: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
    text: {
      type: String,
      default: 'global.action.share.text',
    },
    hideText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return `${this.$t('fleetTask.share.title')} "${this.number}"`
    },
    shareTrackDisabled() {
      const disabledStatuses = ['TEMPORARY', 'DRAFT', 'SCHEDULED', 'CANCELED']
      return disabledStatuses.includes(this.rawStatus)
    },
    computedText() {
      const translation = this.$t(this.text)

      if (translation) {
        return translation
      }

      return this.text
    },
    tooltipText() {
      return this.$t('fleetTaskInstant.tooltip.tracking')
    },
  },
}
</script>
